<template>
    <CompassInput ref="input" :value="value" :placeholder="placeholder" />
</template>

<script>
import IMask from 'imask';
export default {
    props: {
        value: {
            type: String,
            required: true,
        },
        placeholder: {
            type: String,
            default: '',
        },
        lazyMask: {
            type: Boolean,
            default: false,
        },
        useSecond: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            mask: null,
        };
    },
    mounted() {
        const maskOptions = {
            mask: this.useSecond ? 'HH:mm:ss' : 'HH:mm',
            pattern: this.useSecond ? 'HH:mm:ss' : 'HH:mm',
            blocks: {
                HH: {
                    mask: '00',
                    maxLength: 2,
                    placeholderChar: '0',
                },
                mm: {
                    mask: IMask.MaskedRange,
                    from: 0,
                    to: 59,
                    maxLength: 2,
                    placeholderChar: '0',
                },
                ss: {
                    mask: IMask.MaskedRange,
                    from: 0,
                    maxLength: 2,
                    to: 59,
                    placeholderChar: '0',
                },
            },
            lazy: this.lazyMask,
        };

        if (!this.useSecond) {
            delete maskOptions.blocks.ss;
        }

        this.mask = IMask(this.$refs.input.$el.querySelector('input'), maskOptions);
        this.mask.on('accept', () => {
            this.$emit('update:value', this.mask.value);
        });
    },
};
</script>
